import { render, staticRenderFns } from "./ChoicesTask.vue?vue&type=template&id=3f8edbd0&scoped=true"
import script from "./ChoicesTask.vue?vue&type=script&lang=ts"
export * from "./ChoicesTask.vue?vue&type=script&lang=ts"
import style0 from "./ChoicesTask.vue?vue&type=style&index=0&id=3f8edbd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8edbd0",
  null
  
)

export default component.exports